<div class="container text-center space-y-5 mt-5">
  <h4>Vehicle Name - {{vehicleName}}</h4>
  <hr class="border-t-2 border-black-300">
  <img [src]="vehicleImageUrl" class='object-cover w-full rounded-[1rem]' alt="{{vehicleName}}">
</div>
